import { EventCategoryView } from '@/components/feature/event/event-category-view';
import { EventDetailPageView } from '@/components/feature/event/event-detail-page';
import { EventListView } from '@/components/feature/event/event-list-view';
import { EventPageHeader } from '@/components/feature/event/event-page-header';
import { EventPageLayout } from '@/components/feature/event/event-page-layout';
import { useOrientation } from '@/hooks';
import { useEventPageMenuMeta } from '@/hooks/usePageMenuMeta';
import type { EventBenefitCategoryCode, EventListItem, EventView } from '@/types/event';
import { useCallback, useState } from 'react';
import styles from './EventPage.module.scss';

export default function EventPage() {
    const { isHorizontal } = useOrientation();
    const { title: eventTitle, description: eventDescription } = useEventPageMenuMeta();

    const [view, setView] = useState<EventView>('category');
    const [selectedCategoryCode, setSelectedCategoryCode] = useState<EventBenefitCategoryCode | null>(null);
    const [listPageIndex, setListPageIndex] = useState(0);
    const [selectedEvent, setSelectedEvent] = useState<EventListItem | null>(null);

    const handleSelectCategory = useCallback((categoryCode: EventBenefitCategoryCode) => {
        setSelectedCategoryCode(categoryCode);
        setListPageIndex(0);
        setView('list');
    }, []);

    const handleSelectEvent = useCallback((item: EventListItem) => {
        setSelectedEvent(item);
        setView('detail');
    }, []);

    const handleBackToList = useCallback(() => {
        setSelectedEvent(null);
        setView('list');
    }, []);

    const handleBackToCategory = useCallback(() => {
        setSelectedCategoryCode(null);
        setListPageIndex(0);
        setView('category');
    }, []);

    const handlePageChange = useCallback((pageIndex: number) => {
        setListPageIndex(pageIndex);
    }, []);

    return (
        <EventPageLayout>
            <EventPageHeader title={eventTitle} description={eventDescription} isHorizontal={isHorizontal} />

            <div className={styles.view}>
                {view === 'category' && <EventCategoryView onSelectCategory={handleSelectCategory} />}

                {view === 'list' && selectedCategoryCode && (
                    <EventListView
                        categoryCode={selectedCategoryCode}
                        initialPageIndex={listPageIndex}
                        onSelectEvent={handleSelectEvent}
                        onBack={handleBackToCategory}
                        onPageChange={handlePageChange}
                    />
                )}

                {view === 'detail' && selectedEvent && <EventDetailPageView event={selectedEvent} onBack={handleBackToList} />}
            </div>
        </EventPageLayout>
    );
}
